import React from 'react'

const ArrowUp = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      fill="none"
      viewBox="0 0 12 7"
      {...props}
      ref={ref}
    >
      <path
        stroke="#71717A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m1 6 5-5 5 5"
      ></path>
    </svg>
  ),
)
ArrowUp.displayName = 'ArrowUp'

export { ArrowUp }
